import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import parse from 'html-react-parser';
import GLOBAL_CONFIG from '../../config/config';
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle, navParticipationMenu, scrollToElement } from '../../modules/helpers';

class Transfert extends Component {
    //huhu

    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
        };
        this.resize = this.resize.bind(this);
    }
    resize() {
        // set isMobile to true if the device is a mobile and false otherwise 
        this.setState({ isMobile: window.innerWidth <= 768 });
    }
    componentWillMount() {
        window.scrollTo(0, 0);
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentDidMount() {
        const { t } = this.props;
        //Active menu participation - mitmachen
        navParticipationMenu(true);

        //Scroll to navigation menu
        scrollToElement();

        //Remove main loader
        mainLoaderToggle('hide');

        //Virtual page
        appGoogleTracking.dataLayerPush({
            'customEvent': {
                'event': 'virtual-page',
                'virtualUri': GLOBAL_CONFIG.Route.thankyou,
                'pageTitle': t('Meta.title'),
                'ParticipantId': window.PARTICIPATION_ID
            }
        });
    }

    componentWillUnmount() {
        //Remove active menu participation - mitmachen
        navParticipationMenu(false);

        //Show mainloader
        mainLoaderToggle('show');
    }

    DisplayCards(t) {
        const boxs = t("Page.Confirmation.boxs", { returnObjects: true });
        return (
            <div className="s-card-container">
                {
                    boxs.map(({ img, platzhalter, title, copy, button,tag }) => (
                        <div className="s-card">
                            <img src={img} alt="" />
                            {platzhalter ? (<img src={platzhalter} alt="" className="platzhalter" />) : null}
                            <div className="s-card__copy">
                                <h3>{parse(title)}</h3>
                                <p>{parse(copy)}</p>
                                <a href={button.href} target="_blank" 
                                    data-event={tag.dataEvent}
                                    data-category={tag.dataCategory}
                                    data-action={tag.dataAction}
                                    data-label={tag.dataLabel} 
                                    onClick={(e) => {
                                    appGoogleTracking.processEventCTANavLink(e)}}
                                >
                                    <div className="btn__container btn--secondary-lilac btn--hover">
                                        <span className="btn__text"> {button.text} </span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    render() {
        const { t } = this.props;

        return (
            <div className={`content-confirmation content-confirmation__${window.PROMOTION_CAMPAIGN}`}>
                <div className="s-content-title">
                    {/* <h1>{parse(t('Page.Confirmation.title'))}</h1> */}
                    <h1>Vielen Dank</h1>
                    <h2 style={{ fontSize: '24px' }}>Wir werden dir den Betrag für das Milka Nascher-Ei in ca. 6 Wochen auf dein Konto überweisen. </h2>
                </div>
                {this.DisplayCards(t)}
            </div>
        );
    }

}

export default withTranslation()(Transfert);